/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

/** Common Components */
import Buttons from "../../../../../components/ui/button/Buttons";
import FinalMolGrid from "../../../../../components/FinalMolGrid/FinalMolGrid";
import Checkbox from "../../../../../components/finalForms/ui/inputs/checkBox/CheckBox";
import SearchBar from "../../../../../components/ui/searchBar/SearchBar";

/** Common Services & Data Files */
import SwalAlert from "../../../../../services/swalService/SwalService";
import ToastService from "../../../../../services/toastService/ToastService";

/** Configuration Files */
import { RefrenceSynergyTaskGridConfig } from "./config/RefrenceSynergyTaskGridConfig";

/** RTK Query */
import { useAddAttachedSynergyTasksMutation, useGetAllUnAssignSynergyTaskMutation, } from "../../../../../app/services/projectSynergyAPI";

/** Custom Hooks */
import useDebounce from "../../../../../app/customHooks/useDebounce";

const RefrenceSynergyTaskgrid = (props) => {
    const molGridRef = useRef();
    const [dataSource, setDataSource] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [refTaskListData, setRefTaskListData] = useState([]);
    const [showCompletedTask, setShowCompletedTask] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const { error } = SwalAlert();

    const debouncedSearch = useDebounce(searchTerm, 300);

    const [getAllUnAssignSynergyTask, {
        isLoading: isgetAllUnAssignSynergyTaskLoading,
        isSuccess: isgetAllUnAssignSynergyTaskSuccess,
        data: getAllUnAssignSynergyTaskData,
    },] = useGetAllUnAssignSynergyTaskMutation();

    const [addAttachedSynergyTasks, {
        isLoading: isaddAttachedSynergyTasksAdding,
        isSuccess: isaddAttachedSynergyTasksSuccess,
        data: addAttachedSynergyTasksData
    },] = useAddAttachedSynergyTasksMutation();

    const getUnAssignSynergyTaskList = (pageObject) => {
        const request = {
            pagination: {
                pageNumber: pageObject.pagination?.pageNumber || 1, 
                pageSize: pageObject.pagination?.pageSize || 10
            },
            filters: {
                searchText: debouncedSearch
            },
            projectId: props.projectId,
            showCompletedTask: showCompletedTask,
        }
        getAllUnAssignSynergyTask(request);
    }

    const getAllAttachTask = (pageObject) => {
        getUnAssignSynergyTaskList(pageObject)
    }

    const handleOnChange = (dataField, newValue) => {
        setShowCompletedTask(newValue)
    }

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handlePageChange = (page) => {        
        const request = {
            pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
            filters: { searchText: debouncedSearch },
        };
        getAllAttachTask(request);
    }

    useEffect(() => {
        if (molGridRef.current) {
            const pageObject = molGridRef.current.getDefulatPageObject();
            getUnAssignSynergyTaskList(pageObject);
        }
    }, [debouncedSearch, props.projectId, showCompletedTask]);

    useEffect(() => {
        if (!isgetAllUnAssignSynergyTaskLoading && isgetAllUnAssignSynergyTaskSuccess && getAllUnAssignSynergyTaskData) {
            if (getAllUnAssignSynergyTaskData.dataSource) {
                setDataSource(getAllUnAssignSynergyTaskData.dataSource);
              }
              if (getAllUnAssignSynergyTaskData.totalRecord) {
                setTotalRowCount(getAllUnAssignSynergyTaskData.totalRecord);
              }
        }
    }, [isgetAllUnAssignSynergyTaskLoading, isgetAllUnAssignSynergyTaskSuccess, getAllUnAssignSynergyTaskData]);

    useEffect(() => {
        if (isaddAttachedSynergyTasksSuccess && addAttachedSynergyTasksData) {
            if (addAttachedSynergyTasksData.errorMessage.includes("select")) {
                ToastService.error(addAttachedSynergyTasksData.errorMessage);
                return;
            } else {
                ToastService.success(addAttachedSynergyTasksData.errorMessage);
                props.onSuccess();
            }
        }
    }, [isaddAttachedSynergyTasksSuccess, addAttachedSynergyTasksData]);

    const handleColumnsChange = (fieldName, rowData, rowIndex) => {
        setRefTaskListData((prev) => {
            if (rowData.isSelected) {
                return [...prev, rowData];
            } else {
                return prev.filter((task) => task.taskId !== rowData.taskId);
            }
        });
    };

    const handleAddClick = () => {
        let refTaskIds = refTaskListData.map((item) => item.taskId).toString();
        if (refTaskIds === "") {
            error("Please select task to attach synergy");
        }
        else {
            const req = {
                linkedTaskIds: refTaskIds,
                synergyId: props.synergyId,
            };
            addAttachedSynergyTasks(req);
        }
    };

    const handleCloseClick = () => {
        props?.onClose();
    };

    return (
        <div className="reference-task-grid">
            <div className="d-flex justify-content-center align-items-center mb-3 px-1 col-12">
                <div className="col-3">
                    <Checkbox
                        name="showCompletedTask"
                        label="Show Completed Task"
                        isdisable={false}
                        checked={showCompletedTask}
                        dataField="showCompletedTask"
                        onChange={handleOnChange}
                    /></div>

                <div className="col-9">
                    <SearchBar
                        handleChange={handleSearchChange} />
                </div>
            </div>

            <FinalMolGrid
                ref={molGridRef}
                dataSource={dataSource}
                allowPagination={true}
                pagination={{
                    totalCount: totalRowCount,
                    currentPage:1,
                    pageSize:10,
                  }}
                isLoading={isgetAllUnAssignSynergyTaskLoading}
                onColumnChange={handleColumnsChange}
                configuration={RefrenceSynergyTaskGridConfig}
                onPageChange={handlePageChange}
            />
            <div className="col-12 d-flex justify-content-end mt-4 button-submit">
                <Buttons
                    textWithIcon={false}
                    fontIcon={false}
                    buttonTypeClassName="dark-btn"
                    buttonText="Cancel"
                    onClick={handleCloseClick}
                />

                <Buttons
                    textWithIcon={true}
                    fontIcon={true}
                    iconName="ic:round-add"
                    buttonTypeClassName="theme-btn ml-2"
                    buttonText="Attach Task"
                    onClick={handleAddClick}
                    isLoading={isaddAttachedSynergyTasksAdding}
                />
            </div>
        </div>
    );
}

RefrenceSynergyTaskgrid.propTypes = {
    projectId: PropTypes.number.isRequired,
    onSuccess: PropTypes.func,
    onClose: PropTypes.func,
    synergyId: PropTypes.number.isRequired,
}
export default RefrenceSynergyTaskgrid;